module.exports = __webpack_public_path__ + "img/Boundary-Protection.03679494.png";